"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _dockBar = require("./dockBar");

var _dockDrawer = require("./dockDrawer");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _reactTransitionGroup = require("react-transition-group");

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Dock = function Dock(_ref) {
  var children = _ref.children,
      hasDrawer = _ref.hasDrawer,
      drawerOpen = _ref.drawerOpen,
      props = _objectWithoutProperties(_ref, ["children", "hasDrawer", "drawerOpen"]);

  var TRANSITION_TIMEOUT = 300;
  return _react.default.createElement(_reactTransitionGroup.Transition, _extends({
    in: drawerOpen,
    timeout: TRANSITION_TIMEOUT
  }, (0, _getNativeProps.default)(props)), function (state) {
    var classes = {
      'co-dock': true,
      'co-dock--has-drawer': hasDrawer,
      'co-dock--drawer-open': drawerOpen,
      'co-dock--drawer-exiting': state === 'exiting'
    };
    return _react.default.createElement(_styler.default, {
      classNames: classes
    }, function (styles) {
      return _react.default.createElement("div", {
        className: styles
      }, children);
    });
  });
}; // Dock Bar


Dock.Bar = _dockBar.DockBar;
Dock.Container = _dockBar.DockContainer;
Dock.Nav = _dockBar.DockNav;
Dock.Button = _dockBar.DockButton;
Dock.Divider = _dockBar.DockDivider;
_dockBar.DockBar.displayName = 'Dock.Bar';
_dockBar.DockContainer.displayName = 'Dock.Container';
_dockBar.DockNav.displayName = 'Dock.Nav';
_dockBar.DockButton.displayName = 'Dock.Button';
_dockBar.DockDivider.displayName = 'Dock.Divider'; // Dock Drawer

Dock.Drawer = _dockDrawer.DockDrawer;
Dock.Header = _dockDrawer.DockHeader;
Dock.List = _dockDrawer.DockList;
Dock.Item = _dockDrawer.DockItem;
Dock.Actions = _dockDrawer.DockActions;
_dockDrawer.DockDrawer.displayName = 'Dock.Drawer';
_dockDrawer.DockHeader.displayName = 'Dock.Header';
_dockDrawer.DockList.displayName = 'Dock.List';
_dockDrawer.DockItem.displayName = 'Dock.Item';
_dockDrawer.DockActions.displayName = 'Dock.Actions';
Dock.propTypes = {
  children: _propTypes.any.isRequired,
  hasDrawer: (0, _airbnbPropTypes.requiredBy)('drawerOpen', _propTypes.bool),
  drawerOpen: _propTypes.bool
};
var _default = Dock;
exports.default = _default;
Dock.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Dock",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "hasDrawer": {
      "type": {
        "name": "custom",
        "raw": "requiredBy('drawerOpen', bool)"
      },
      "required": false,
      "description": ""
    },
    "drawerOpen": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};